export default __webpack_public_path__ + "static/media/info_mine.min.c93beb17.png";